// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-3176db9f] .el-dialog__body {\n  padding: 0px 10px;\n}\n", ""]);
// Exports
module.exports = exports;
